// extracted by mini-css-extract-plugin
export default {"position-button-block":"app-people-NewPersonFormAdditional-NewPersonFormAdditional-module__JSj2vEbSP9rgSENqtR7e"};